export default {"src":"/_next/static/media/pl.f3e8abc0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};